import { render, staticRenderFns } from "./singleBlogDetails.vue?vue&type=template&id=be94cdc8&scoped=true&lang=html&"
import script from "./singleBlogDetails.vue?vue&type=script&lang=js&"
export * from "./singleBlogDetails.vue?vue&type=script&lang=js&"
import style0 from "./singleBlogDetails.vue?vue&type=style&index=0&id=be94cdc8&lang=scss&scoped=true&"
import style1 from "./singleBlogDetails.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be94cdc8",
  null
  
)

export default component.exports